import { render, staticRenderFns } from "./FullTerm.vue?vue&type=template&id=bd211514&scoped=true"
import script from "./FullTerm.vue?vue&type=script&lang=js"
export * from "./FullTerm.vue?vue&type=script&lang=js"
import style0 from "./FullTerm.vue?vue&type=style&index=0&id=bd211514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd211514",
  null
  
)

export default component.exports